import * as React from "react"
import { Hidden, Row, Visible } from "react-grid-system"
import styled from "styled-components"
import { HorizontalSpacer, Spacer } from "../atoms/spacers"
import { useMyOrganization } from "../../hooks/useMyOrganization"
import Card from "../atoms/Card"
import Subtitle from "../atoms/typography/Subtitle"
import PrimaryButton from "../atoms/buttons/PrimaryButton"
import SecondaryButton from "../atoms/buttons/SecondaryButton"
import { SettingsIcon } from "../atoms/icons/SettingsIcon"
import PendingInvitesCard, { PendingInviteApiType } from "../molecules/PendingInviteCard"
import EditMemberSectionDropdown from "./EditMemberSectionDropdown"
import { Member } from "../../utils/models"
import InviteMemberToOrganizationButton from "../molecules/InviteMemberToOrganizationButton"
import { useMyUser } from "../../hooks/useMyUser"

const ORGANIZATION_ROLE_ADMIN = "Admin"

interface Props {
  members: Array<Member>
  pendingInvites: Array<PendingInviteApiType>
  onClickInviteToGroup: (member: Member) => void
  cardsOpen: Array<string>
  onClickHandleOpenCard: (id: string) => void
}

const PaddedRow = styled(Row)`
  padding: ${(props) => props.theme.spacings.large};
`

const EditButtons = styled.div`
  display: flex;
`

const OrganizationMembersCard: React.FC<Props> = ({
  members,
  pendingInvites,
  onClickInviteToGroup,
  cardsOpen,
  onClickHandleOpenCard,
}) => {
  const [editMode, setEditMode] = React.useState(false)
  const { myOrganization } = useMyOrganization()
  const { user } = useMyUser()

  const onClickManage = () => setEditMode(!editMode)

  const checkIsOpen = (id: string) => {
    return cardsOpen.includes(id)
  }

  const hasPermission = user?.organizationRole?.name === ORGANIZATION_ROLE_ADMIN

  return (
    <div>
      <Card>
        <PaddedRow nogutter justify="between" align="center">
          <Subtitle>{myOrganization?.name}</Subtitle>
          {!editMode && hasPermission && (
            <PrimaryButton title="Manage members" icon={<SettingsIcon />} onClick={onClickManage} />
          )}
          {editMode && (
            <EditButtons>
              <Hidden xs>
                <InviteMemberToOrganizationButton orgId={myOrganization?.id!} orgName={myOrganization?.name!} />
              </Hidden>
              <Visible xs>
                <InviteMemberToOrganizationButton
                  orgId={myOrganization?.id!}
                  orgName={myOrganization?.name!}
                  title="Invite"
                />
              </Visible>
              <Spacer spacing={1} />
              <SecondaryButton title="Done" onClick={onClickManage} />
            </EditButtons>
          )}
        </PaddedRow>
        {pendingInvites?.length > 0 && <PendingInvitesCard pendingInvites={pendingInvites} />}
        {members.map((member) => (
          <div key={member.member.id}>
            <EditMemberSectionDropdown
              myOrgName={myOrganization?.name ?? ""}
              member={member}
              canEdit={editMode}
              onClickInviteToGroup={() => onClickInviteToGroup(member)}
              open={checkIsOpen(member.member.id)}
              onClickOpen={onClickHandleOpenCard}
            />
            <HorizontalSpacer spacing={0.5} />
          </div>
        ))}
      </Card>
    </div>
  )
}

export default OrganizationMembersCard
